<template>
  <vue-good-table
  @on-row-click="viewTicket"
  :columns="columns"
  :rows="rows"
  :row-style-class="trClass"
  :paginationOptions="{
    enabled: true,
    perPage: 10,
    position: 'top',
    perPageDropdown: [5, 10, 15],
    dropdownAllowAll: false,
    nextLabel: 'següent',
    prevLabel: 'anterior',
    rowsPerPageLabel: 'Files per pàgina',
    ofLabel: 'de',
    allLabel: 'All',
  }"
  :sortOptions="{
    initialSortBy: {field: 'data_creacio', type: 'desc'}
  }">
  <div slot="emptystate">
    No tens cap incidència
    <font-awesome-icon :icon="['fas', 'check']"/>
  </div>
    <template slot="table-row" slot-scope="props">
      <span v-if="['usuaris','gestors'].includes(props.column.field)">
        <span>
          {{ props.row[props.column.field].join(", ") }}
        </span>
      </span>
      <span v-else-if="['categoria','grup','incidencia'].includes(props.column.field)" :title="props.row.categoria.descripcio">
          {{ props.row[props.column.field]|truncate(30) }}
      </span>
      <span v-else-if="props.column.field == 'estat'" :title="props.row.estat.nom">
          {{ props.row.estat.nom }}
      </span>
      <span v-else :title="props.row[props.column.field]">
        {{props.row[props.column.field]|truncate(50)}}
      </span>
    </template>
  </vue-good-table>
</template>

<script>

export default {
  computed: {
    user () {
      return this.$store.getters.getUser
    }
  },
  props: {
    table_rows: {
      required: true,
      type: Array
    },
    states: {
      required: true,
      type: Array
    },
  },
  watch: {
    states: function (newVal) {
      const estatIdx = this.columns.findIndex(c => c.field === 'estat')
      if (estatIdx !== -1) {
        this.$set(this.columns[estatIdx].filterOptions, 'filterDropdownItems', newVal)
      }
    },
    table_rows: function (newVal) {
      this.rows = newVal
    }
  },
  filters: {
    truncate: function (value, limit) {
      if (value && value.length > limit) {
        value = value.substring(0, (limit - 3)) + '...'
      }
      return value
    }
  },
  methods: {
    trClass: function (row) {
      return row.estat.color + ' text-nowrap'
    },
    filterState: function (data, filterString) {
      return data.nom === filterString
    },
    viewTicket: function (params) {
      this.$router.push({ name: 'TicketPage', params: { 'id': params.row.id } })
    }
  },
  data () {
    return {
      rows: [],
      columns: [
        {
          label: 'Detalls',
          field: 'detalls',
          type: 'string',
          html: false,
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: '' // placeholder for filter input
          }
        },
        {
          label: 'Usuaris',
          field: 'usuaris',
          type: 'array',
          width: '100px',
          html: false,
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: '' // placeholder for filter input
          }
        },
        {
          label: 'Categoria',
          field: 'categoria',
          type: 'string',
          filterable: true,
          filterOptions: {
            enabled: true // enable filter for this column
          }
        },
        {
          label: 'Subcategoria',
          field: 'grup',
          type: 'string',
          filterable: true,
          filterOptions: {
            enabled: true // enable filter for this column
          }
        },
        {
          label: 'Incidencia',
          field: 'incidencia',
          type: 'string',
          filterable: true,
          filterOptions: {
            enabled: true // enable filter for this column
          }
        },
        {
          label: 'Data de creació',
          field: 'data_creacio',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd k:m',
          dateOutputFormat: 'MMM d yyyy' // outputs Mar 16th 2018
        },
        {
          label: 'Espai',
          field: 'aula',
          type: 'string',
          width: '75px',
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Aula' // placeholder for filter input
          }
        },
        {
          label: 'Gestors',
          field: 'gestors',
          type: 'array',
          width: '100px',
          html: false,
          filterable: true,
          filterOptions: {
            enabled: true, // free-text filter for this column
            placeholder: '' // placeholder for filter input
          }
        },
        {
          label: 'Estat',
          field: 'estat',
          type: 'string',
          filterable: true,
          tdClass: this.tdColor,
          filterOptions: {
            enabled: true, // enable filter for this column
            filterDropdownItems: [],
            filterFn: this.filterState,
            placeholder: 'Tots'
          }
        }
      ]
    }
  }
}
</script>

<style scoped>

</style>
